import React from 'react';
import Modal from '@medflex/components/stories/Modal';
import PhysicianStatusModalBody from '@medflex/components/stories/PhysicianStatusModalBody';
import { useTranslation } from 'react-i18next';
import { format } from '@medflex/i18n';
import getFullNameWithTitle from '@medflex/utils/getFullNameWithTitle';
import getInitials from '@medflex/utils/getInitials';
import useSelectedMainContact from '../hooks/useSelectedMainContact';
import usePhysicianStatus from '../hooks/usePhysicianStatus';
import useModal from '../hooks/useModal';
import { MODALS } from '../hooks/useIsModal';
import useSelectedSessionChatId from '../hooks/useSelectedSessionChatId';
import useSessionChat from '../hooks/useSessionChat';

const PhysicianStatusModal = () => {
  const { t } = useTranslation();
  const selectedContact = useSelectedMainContact();
  const sessionChatId = useSelectedSessionChatId();
  const { chat } = useSessionChat({ id: sessionChatId });
  const physicianUserId = selectedContact?.user?.id || chat?.physicianUserId;

  const { status: statusMap } = usePhysicianStatus(physicianUserId ? [physicianUserId] : []);
  const { close } = useModal();

  const closeModal = async () => {
    close({ modal: MODALS.PHYSICIAN_STATUS_MODAL });
  };

  const { status, statusSetAt, user } = statusMap[physicianUserId] || {};
  if (!status || !user) return null;

  return (
    <Modal title={t('contact_status.modal.title')}>
      <PhysicianStatusModalBody
        physicianName={getFullNameWithTitle(user)}
        avatarSrc={user.avatar}
        avatarInitials={user.avatar || getInitials(user)}
        note={t('contact_status.modal.note', { date: format(statusSetAt, 'DD. MMMM YYYY') })}
        statusMessage={status}
        closeButtonLabel={t('contact_status.modal.close_button')}
        clickHandler={closeModal}
      />
    </Modal>
  );
};

export default PhysicianStatusModal;
